const variantScrollSessionKey = 'variant-scroll-restore';
const variantScrollYSessionKey = 'variant-scroll-restore-y';
export const markVariantNavigationForRestore = (e) => {
    const link = e?.currentTarget?.matches?.('a.variant-table__article-nr[href]')
        ? e.currentTarget
        : e?.target?.closest?.('a.variant-table__article-nr[href]');
    if (!link?.href)
        return;
    const currentParams = new URLSearchParams(window.location.search);
    const hideInternal = currentParams.get('hide_internal');
    if (hideInternal === '1') {
        const targetUrl = new URL(link.href, window.location.origin);
        if (targetUrl.searchParams.get('hide_internal') !== '1') {
            targetUrl.searchParams.set('hide_internal', '1');
            link.href = targetUrl.toString();
        }
    }
    sessionStorage.setItem(variantScrollSessionKey, '1');
    sessionStorage.setItem(variantScrollYSessionKey, String(window.scrollY || 0));
};
const getStickyOffset = () => {
    const headerTotalHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-total-height'));
    const header = document.querySelector('header.header');
    const headerHeight = Number.isFinite(headerTotalHeight)
        ? headerTotalHeight
        : header?.offsetHeight || 0;
    const productNav = document.querySelector('.product-page-nav');
    const productNavHeight = productNav?.offsetHeight || 0;
    const variantsHeading = document.querySelector('#variants h3.section-title__main');
    const variantsHeadingHeight = variantsHeading?.offsetHeight || 0;
    return headerHeight + productNavHeight + variantsHeadingHeight;
};
export const restoreVariantScrollFromSession = () => {
    if (sessionStorage.getItem(variantScrollSessionKey) !== '1')
        return;
    sessionStorage.removeItem(variantScrollSessionKey);
    sessionStorage.removeItem(variantScrollYSessionKey);
    const target = document.getElementById('variants');
    if (!target)
        return;
    const headingTarget = target.querySelector('#variants h3.section-title') || target;
    const scrollToHeading = () => {
        const headingTop = headingTarget.getBoundingClientRect().top + window.pageYOffset;
        const desiredTop = headingTop - getStickyOffset();
        const docMax = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo({
            top: Math.max(0, Math.min(docMax, desiredTop)),
            behavior: 'auto',
        });
    };
    // Wait for sticky/layout state, then do a second pass for late shifts.
    window.setTimeout(() => {
        scrollToHeading();
        window.requestAnimationFrame(scrollToHeading);
    }, 180);
};
export const initVariantScrollRestoration = () => {
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }
    if (!window.__litiumVariantScrollListenerBound) {
        document.addEventListener('click', markVariantNavigationForRestore, true);
        window.__litiumVariantScrollListenerBound = true;
    }
};
